import * as Sentry from '@sentry/react';

// A frontend DSN is public by design (it ships in the bundle), so it is hardcoded rather than an env var.
const SENTRY_DSN = 'https://f901b37bf058369580889404f7bcc17f@o4512205600718848.ingest.de.sentry.io/4512205609959504';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function initErrorTracking(enabled = process.env.REACT_APP_SENTRY_ENABLED === 'true') {
  if (!enabled) return;
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: window.location.hostname,
    integrations: [Sentry.browserTracingIntegration()],
    // Traffic is low, so trace every page load and API call; lower this as traffic grows.
    tracesSampleRate: 1.0,
    // Trace headers go to our own API so frontend and backend spans join into one trace.
    tracePropagationTargets: BACKEND_URL ? [/^\//, BACKEND_URL] : [/^\//],
  });
}

// The UI catches API failures to show a message, so they never reach Sentry's global handlers.
// Report the ones that mean something is wrong on our side (5xx, timeouts) — not user mistakes.
export function reportServerError(error: Error, context: { url: string; status?: number }) {
  if (context.status !== undefined && context.status < 500) return;
  Sentry.captureException(error, { extra: context });
}
